<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :width="width"
    :isHide="isHide"
    :isTrain="isTrain"
    :isReject="false"
  >
    <div slot="content">
      <el-form ref="form" label-width="130px" :model="dataForm">
        <div v-if="dataForm.MemberType === 1">
          <el-form-item label="姓名：">
            {{ dataForm.Name }}
          </el-form-item>
          <el-form-item label="手机号：">
            {{ dataForm.Phone }}
          </el-form-item>
          <el-form-item label="性别：">
            {{ dataForm.Sex === 1 ? "男" : "女" }}
          </el-form-item>
          <el-form-item label="民族：">
            {{ dataForm.National }}
          </el-form-item>
          <el-form-item label="出生日期：">
            {{ (dataForm.Birthday * 1000) | formatDate2 }}
          </el-form-item>
          <el-form-item label="证件类型：">
            {{ dataForm.IdType === 1 ? "其他" : "身份证" }}
          </el-form-item>
          <el-form-item label="证件号码：">
            {{ dataForm.IdentityCard }}
          </el-form-item>
          <el-form-item label="工作单位：">
            {{ dataForm.WordUnit }}
          </el-form-item>
          <el-form-item label="地址：">
            {{ dataForm.CityName + dataForm.Address }}
          </el-form-item>
          <el-form-item label="文化程度：">
            {{ formatEdu(dataForm.Education) }}
          </el-form-item>
          <el-form-item label="电子邮箱：">
            {{ dataForm.Email }}
          </el-form-item>
          <el-form-item label="职业：">
            {{ formatPro(dataForm.Professional) }}
          </el-form-item>
          <el-form-item label="身份属性：">
            {{ formatIdentityArr(dataForm.IdentityAttr) }}
          </el-form-item>
          <el-form-item
            label="是否愿意成为红十字救护志愿者："
            label-width="250"
          >
            {{ dataForm.IsVolunteer === 1 ? "是" : "否" }}
          </el-form-item>
          <el-form-item label="学员照片：">
            <div v-for="(image, index) in fileListIdPhotoFile" :key="index">
              <el-row>
                <el-col :span="12" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ image.name }}</el-col>
                <el-col
                  :span="12"
                  style="text-align: right; padding-right: 20px"
                >
                  <el-button type="text" @click="showImageViewer(image)">查看</el-button>
                  <el-button type="text" @click="onFilePreviewIdPhotoFile(image)">下载</el-button>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
          <el-form-item label="缴费通知单：" v-if="dataForm.PayContentFile!=='' && dataForm.ApplyStatus === 1">
             <el-row>
                <el-col :span="12">缴费通知单.jpg</el-col>
                <el-col
                  :span="12"
                  style="text-align: right; padding-right: 20px"
                >
                  <el-button type="text" @click="showImageViewer({url: dataForm.PayContentFile})">查看</el-button>
                  <el-button type="text" @click="onFilePreviewIdPhotoFile(image)">下载</el-button>
                </el-col>
              </el-row>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="机构名称：">
            {{ dataForm.Name }}
          </el-form-item>
          <el-form-item label="机构地址：">
            {{ dataForm.Address }}
          </el-form-item>
          <el-form-item label="联系人：">
            {{ dataForm.ContactUser }}
          </el-form-item>
          <el-form-item label="联系手机号：">
            {{ dataForm.Phone }}
          </el-form-item>
          <el-form-item label="联系人单位职务：">
            {{ dataForm.ContactPosition }}
          </el-form-item>
          <el-form-item label="报名人数：">
            {{ dataForm.SignUpNum }}
          </el-form-item>
          <el-form-item label="费用：">
            {{ dataForm.Amount }}
          </el-form-item>
          <el-form-item label="报名期数：">
            {{ dataForm.TrainTitle }}
          </el-form-item>
          <el-form-item label="报名人员信息：">
            <el-upload
              class="upload-demo"
              drag
              action="/api/File/FileUpload"
              multiple
              :on-preview="onFilePreview"
              :file-list="fileList"
            >
            </el-upload>
          </el-form-item>
          <el-form-item label="合作协议：">
            <el-upload
              class="upload-demo"
              drag
              action="/api/File/FileUpload"
              multiple
              :on-preview="onFilePreviewAgreeFile"
              :file-list="fileListAgreeFile"
            >
            </el-upload>
          </el-form-item>
          <el-form-item label="学员照片：">
            <!-- <el-upload
              class="upload-demo"
              drag
              action="/api/File/FileUpload"
              multiple
              :on-preview="onFilePreviewIdPhotoFile"
              :file-list="fileListIdPhotoFile"
            >
            </el-upload> -->
            <div v-for="(image, index) in fileListIdPhotoFile" :key="index">
              <el-row>
                <el-col :span="12">{{ image.name }}</el-col>
                <el-col
                  :span="12"
                  style="text-align: right; padding-right: 20px"
                >
                  <el-button type="text" @click="showImageViewer(image)">查看</el-button>
                  <el-button type="text" @click="onFilePreviewIdPhotoFile(image)">下载</el-button>
                </el-col>
              </el-row>
            </div>
          </el-form-item>
          <el-form-item label="缴费通知单：" v-if="dataForm.PayContentFile!=='' && dataForm.ApplyStatus === 1">
            <el-row>
                <el-col :span="12">缴费通知单</el-col>
                <el-col
                  :span="12"
                  style="text-align: right; padding-right: 20px"
                >
                  <el-button type="text" @click="showImageViewer({url: dataForm.PayContentFile})">查看</el-button>
                  <el-button type="text" @click="onFilePreviewIdPhotoFile(image)">下载</el-button>
                </el-col>
              </el-row>
          </el-form-item>
        </div>
        <div
          tabindex="-1"
          class="el-image-viewer__wrapper"
          style="z-index: 2021"
          v-if="isShowImageViewer"
        >
          <div class="el-image-viewer__mask" @click="closeImageViewer" />
          <div class="el-image-viewer__canvas">
            <img
              :src="imageViewerUrl"
              class="el-image-viewer__img"
              style="
                transform: scale(1) rotate(0deg);
                margin-left: 0px;
                margin-top: 0px;
                max-height: 100%;
                max-width: 100%;
              "
            />
          </div>
        </div>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import OfUpload from "@/components/controls/of_upload/of_upload";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
import { formatData } from "@/utils";
import { mapGetters } from "vuex";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide: {
      type: Boolean,
      default: false,
    },
    isTrain: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dataForm: {
        PayContentFile: ''
      }, //表单对象
      fileList: [], //附件数组
      fileListAgreeFile: [],
      fileListIdPhotoFile: [],
      width: "45%",
      isShowImageViewer: false,
      imageViewerUrl: ''
    };
  },
  components: {
    workbenchDetail,
    OfUpload,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    closeImageViewer(){
      const vm = this
      vm.isShowImageViewer = false
    },
    showImageViewer(image){
      const vm = this
      vm.imageViewerUrl = image.url
      vm.isShowImageViewer = true
    },
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryTrainApplyById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.getFileIdPhotoFile();
          that.getFile();
          that.getFileAgreeFile();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      api
        .AuditLifeGuardApply(data)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", data);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
    //初始化附件
    getFileAgreeFile() {
      let that = this;
      if (that.dataForm.AgreeFile || that.dataForm.AgreeFile != null) {
        let params = { Id: that.dataForm.AgreeFile };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileListAgreeFile.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    getFileIdPhotoFile() {
      let that = this;
      if (that.dataForm.IdPhotoFile || that.dataForm.IdPhotoFile != null) {
        let params = { Id: that.dataForm.IdPhotoFile };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileListIdPhotoFile.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    getFile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //点击下载
    // onFilePreview(file) {
    //   //saveAs(file.url, file.name);
    // },
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
    onFilePreviewAgreeFile(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
    onFilePreviewIdPhotoFile(file) {
      saveAs("/api/File/Download?Id=" + file.response.Data.FileId, file.name);
    },
    formatIdentityArr(item) {
      return formatData(item, this.identityAttr);
    },
    formatEdu(item) {
      return formatData(item, this.education);
    },
    formatPro(item) {
      return formatData(item, this.professional);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload--text {
  display: none !important;
}
.upload-demo >>> .el-icon-close {
  display: none !important;
}
.upload-demo >>> .el-icon-close-tip {
  display: none !important;
}
.upload-demo >>> .el-upload-dragger {
  display: none !important;
}
</style>

<style lang="scss" scoped>
.image-viewer__canvas {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-viewer__img {
  transform: scale(1) rotate(0deg);
  margin-left: 0px;
  margin-top: 0px;
  max-height: 100%;
  max-width: 100%;
}
</style>